import React from "react";
import { Box, Tooltip, IconButton, Menu, MenuItem, ListItemIcon } from "@mui/material";
import { Logout } from '@mui/icons-material';
import '../i18n';
import { useTranslation } from 'react-i18next';
import '../styles/GoogleAuth.css'
import { useUser } from "../context/UserContext"


export default function UserAuthNavBarCompomemt(page) {
    const [t, i18n] = useTranslation();
    const userContext = useUser();
    
    const handleLogout = (res) => {
        userContext.logout();
    };
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
      setAnchorEl(null);
    };
    return (
        <Box>
            <Tooltip title="Профиль">
                <IconButton
                    onClick={handleClick}
                    size="small"
                    sx={{ ml: 2 }}
                    aria-controls={open ? 'account-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    className="outlineBtn"
                    style={{ color: 'white', fontWeight: 'normal', textAlign: 'center' }}
                >
                    {userContext.get_name()}
                </IconButton>
            </Tooltip>
            <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                PaperProps={{
                elevation: 0,
                sx: {
                    overflow: 'visible',
                    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                    mt: 1.5,
                    '& .MuiAvatar-root': {
                    width: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 1,
                    },
                    '&:before': {
                    content: '""',
                    display: 'block',
                    position: 'absolute',
                    top: 0,
                    right: 14,
                    width: 10,
                    height: 10,
                    bgcolor: 'background.paper',
                    transform: 'translateY(-50%) rotate(45deg)',
                    zIndex: 0,
                    },
                },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                <MenuItem onClick={handleLogout}>
                    <ListItemIcon>
                        <Logout fontSize="small" />
                    </ListItemIcon>
                    {t("Выйти")}
                </MenuItem>
            </Menu>
        </Box>
    );
}
